/**
 * НАСЫЩЕННЫЕ СЛОИ СПОСОБНОСТЕЙ ФРАКЦИЙ (расчет — utils/effects/buildFactionAbilityCast):
 * ложатся поверх основных планов из utils/effects/buildAbilityCast. Момент попадания
 * не меняют: под него подогнаны звук и показ итога.
 *
 * Решения владельца по бомбе (2026-10-30) остаются в силе: взрыв виден сверху, все
 * расходится по кругу и не падает вниз экрана; при провале фитиль просто тухнет.
 *
 * Время — в миллисекундах, размеры — доли размера ячейки.
 */

export const FACTION_CAST_COLORS = {
  // Адское пламя суккубов: темнее и краснее розового сердца
  infernal: 0xc4124f,
  infernalLight: 0xff4f7e,
  plum: 0x3a0a2e,
  shield: 0xdce6ff,
  shieldDeep: 0x7f8fb8,
  goblinGlow: 0x9bd61e,
};

// Ход колдовства у отряда: знак на земле, сходящиеся кольца и темнеющее вокруг поле
export const FACTION_CAST_CHARGE = {
  dim: {sizeFactor: 5, alpha: 0.26},
  rune: {radiusFactor: 1.08, innerRadiusFactor: 0.74, turn: 1.1, alpha: 0.95},
  rings: {count: 3, fromFactor: 2.1, lifeShare: 0.72},
  launch: {sizeFactor: 1.9, durationMs: 240, raysSizeFactor: 2.5, raysMs: 520, raysAlpha: 0.85},
  // Хвост кометы за снарядом и дым за ним
  comet: {count: 16, lifeMs: 230, fromSizeFactor: 0.6, toSizeFactor: 0.2},
};

export const SEDUCTION_RICH_CAST = {
  // Цель обречена заранее: штрих-знак сходится на ней к моменту попадания
  lure: {fromFactor: 1.8, toFactor: 1, turn: -0.9, leadMs: 620, alpha: 0.9},
  plumes: {count: 7, everyMs: 95, sizeFactor: 0.42, lifeMs: 520, alpha: 0.5},
  success: {
    flash: {sizeFactor: 3, durationMs: 300},
    waves: [
      {endFactor: 2.5, durationMs: 620, alpha: 0.95, delayMs: 0},
      {endFactor: 1.8, durationMs: 520, alpha: 0.9, delayMs: 130},
    ],
    rays: {sizeFactor: 3.1, durationMs: 860, turn: 0.75, alpha: 0.9},
    // Языки пламени бьют вверх широким веером
    tongues: {count: 16, fan: 1.25, minReachFactor: 1, maxReachFactor: 1.9, lengthFactor: 0.72, thicknessFactor: 0.15, lifeMs: 560},
    // Темный дым расползается от цели
    smoke: {count: 6, sizeFactor: 0.95, spreadFactor: 0.8, lifeMs: 920, alpha: 0.72},
    // Печать на земле под покоренным отрядом: пульсирует и гаснет
    seal: {durationMs: 1000, pulses: 2.5, alpha: 1},
    stream: {
      count: 18,
      spawnMs: 460,
      lifeMs: 620,
      minSizeFactor: 0.14,
      maxSizeFactor: 0.26,
      startRadiusFactor: 0.72,
      endRadiusFactor: 0.2,
      turns: 0.85,
      swirlFlatten: 0.3,
      topJitterFactor: 0.3,
      topLiftFactor: 1.2,
    },
    shake: {durationMs: 140, intensity: 0.0016},
  },
  failure: {
    // Щит цели: шестиугольник вспыхивает и трескается искрами
    shield: {sizeFactor: 1.1, durationMs: 420, alpha: 1},
    wave: {endFactor: 1.6, durationMs: 420, alpha: 0.7},
    shards: {count: 12, reachFactor: 1.35, lengthFactor: 0.42, thicknessFactor: 0.09, lifeMs: 460},
  },
};

export const GOBLINS_BOMB_RICH_CAST = {
  // Прицел на цели сходится к падению бомбы
  sight: {fromFactor: 1.75, toFactor: 1, turn: 1.3, leadMs: 800, alpha: 0.95, fillAlpha: 0.32},
  throwRing: {sizeFactor: 1.8, durationMs: 340, alpha: 0.9},
  blast: {
    waves: [
      {endFactor: 2.8, durationMs: 560, alpha: 1, delayMs: 0},
      {endFactor: 2, durationMs: 480, alpha: 0.9, delayMs: 110},
    ],
    streaks: {count: 18, minReachFactor: 1.1, maxReachFactor: 2.3, lengthFactor: 0.8, thicknessFactor: 0.16, lifeMs: 480},
    rays: {sizeFactor: 2.9, durationMs: 420, turn: 0.45, alpha: 0.95},
    // Выжженный шестиугольник тлеет дольше самого взрыва
    ember: {durationMs: 1200, alpha: 0.9},
  },
  // Разрушение: третья волна и больше всего остального
  destroyed: {extraWave: {endFactor: 3.6, durationMs: 700, alpha: 0.85, delayMs: 200}, streaksScale: 1.5, reachScale: 1.25},
  // Крепость выдержала: сталь и щит вместо огня
  deflected: {shield: {sizeFactor: 1.08, durationMs: 380, alpha: 0.95}, streaks: {count: 9, reachFactor: 1.15, lengthFactor: 0.42, thicknessFactor: 0.09, lifeMs: 340}},
};

export const GOBLINS_TRAP_RICH_CAST = {
  // Капкан: штрих-знак вращается и защелкивается на ячейке
  jaws: {fromFactor: 1.7, toFactor: 0.92, turn: 1.6, leadMs: 560, alpha: 0.95},
  success: {
    flash: {sizeFactor: 2, durationMs: 240},
    // Волна сходится внутрь: капкан захлопнулся, а не взорвался
    inward: {fromFactor: 2, toFactor: 0.82, durationMs: 200, alpha: 0.95},
    teeth: {count: 6, reachFactor: 0.72, lengthFactor: 0.62, thicknessFactor: 0.15, lifeMs: 260},
    // Два коротких отклика контура: щелк-щелк
    pulse: {durationMs: 640, count: 2, alpha: 1},
    rays: {sizeFactor: 2.1, durationMs: 460, turn: 0.5, alpha: 0.85},
  },
  failure: {
    wave: {endFactor: 1.5, durationMs: 400, alpha: 0.6},
  },
  hidden: {
    rays: {sizeFactor: 2.2, durationMs: 460, turn: 0.5, alpha: 0.85},
    wave: {endFactor: 1.7, durationMs: 460, alpha: 0.85},
  },
};

export const LEPRECHAUNS_RICH_CAST = {
  flash: {sizeFactor: 2.4, durationMs: 280},
  waves: [
    {endFactor: 2.3, durationMs: 620, alpha: 0.95, delayMs: 0},
    {endFactor: 1.7, durationMs: 520, alpha: 0.85, delayMs: 140},
  ],
  rune: {radiusFactor: 1.08, innerRadiusFactor: 0.74, turn: 0.9, durationMs: 1150, alpha: 0.95},
  rays: {sizeFactor: 2.9, durationMs: 950, turn: 0.55, alpha: 0.8},
  // Столб изумрудного света поднимается к числу
  beam: {widthFactor: 0.95, coreWidthShare: 0.4, heightFactor: 2.3, durationMs: 950},
  // Фонтан монет: взлетают вокруг отряда и падают обратно, вращаясь на ребро
  coins: {
    count: 14,
    spawnMs: 520,
    lifeMs: 800,
    sizeFactor: 0.3,
    minSpreadFactor: 0.35,
    maxSpreadFactor: 1.15,
    minLiftFactor: 0.9,
    maxLiftFactor: 1.7,
    minSpins: 2,
    maxSpins: 4,
  },
};
